import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { bleachrHTTP } from '../_classes/http';
import { GolfTournament } from '../_interfaces/golf/golf-tournament';

@Injectable({
    providedIn: 'root'
})
export class GolfService {
    constructor(
        private http: bleachrHTTP
    ) { }

    async getTournamentsByTeamID(team_id: string): Promise<GolfTournament[]> {
        return await this.http.get<{ data: GolfTournament[] }>(`${environment.ELIXIR_API_FOUR}/golf/tournaments/${team_id}`)
            .then((res) => res?.data)
    }
}
